<template>
  <div class="mk-vis-warning">
    <Alert class="mk-vis-warning__icon"/> {{warning}}
  </div>
</template>

<script>
/**
 * Warning Message
 * @author David <david.prenninger@gmx.de>
 *
 * This component is a general warning message
 * used to show potential issues with the configuration.
 */
import Alert from 'vue-material-design-icons/Alert.vue';

export default {
  props: {
    warning: String,
  },
  components: {
    Alert,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-vis-warning {
  background-color: $c_warning;
  padding: 5px 30px;
  color: $c_white;
  box-shadow: $bs_md;
  width: 300px;
  position: absolute;
  left: calc(50% - 150px);
  bottom: 60px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  z-index: 2;

  @media (max-width: 900px) {
    width: 200px;
    left: 5px;
    top: 10px;
    bottom: auto;
  }

  &__icon {
    margin-right: 3px;
    margin-top: 2px;
  }
}
</style>
